// Undefined represents "all orders"
export type OrderStatus = undefined | 'in_progress' | 'completed' | 'canceled'

// Undefined represents "all types"
export type OrderType = undefined | 'pickup' | 'delivery' | 'rx' | 'lastmile' | 'scan_and_pay'

export enum OrderSource {
  Marketplace = 'MARKETPLACE',
  PBI = 'PBI',
  Unata = 'UNATA',
  API = 'API',
}
